/* ==========================================================================
   Product Tabs JS
   File: assets/product-tabs.js
   ========================================================================== */

(function () {
  'use strict';

  function initProductTabs(wrapper) {
    var buttons = wrapper.querySelectorAll('.product-tabs__btn');
    var panels = wrapper.querySelectorAll('.product-tabs__panel');
    var dropdownItems = wrapper.querySelectorAll('.product-tabs__dropdown-item');
    var dropdownLabel = wrapper.querySelector('.product-tabs__dropdown-label');

    if (!buttons.length || !panels.length) return;

    function activateTab(index) {
      buttons.forEach(function (btn, i) {
        var isActive = i === index;
        btn.classList.toggle('is-active', isActive);
        btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        btn.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panels.forEach(function (panel, i) {
        var isActive = i === index;
        panel.classList.toggle('is-active', isActive);
        if (isActive) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      // Keep the mobile dropdown UI in sync (label + active item state)
      dropdownItems.forEach(function (item, i) {
        var isActive = i === index;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        if (isActive && dropdownLabel) {
          dropdownLabel.textContent = item.textContent.trim();
        }
      });
    }

    // Initialise roving tabindex: first button in tab order, rest removed
    buttons.forEach(function (btn, i) {
      btn.setAttribute('tabindex', i === 0 ? '0' : '-1');
    });

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        activateTab(i);
      });

      // Keyboard navigation (left/right arrow keys)
      btn.addEventListener('keydown', function (e) {
        var currentIndex = i;
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          var next = (currentIndex + 1) % buttons.length;
          buttons[next].focus();
          activateTab(next);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          var prev = (currentIndex - 1 + buttons.length) % buttons.length;
          buttons[prev].focus();
          activateTab(prev);
        } else if (e.key === 'Home') {
          e.preventDefault();
          buttons[0].focus();
          activateTab(0);
        } else if (e.key === 'End') {
          e.preventDefault();
          buttons[buttons.length - 1].focus();
          activateTab(buttons.length - 1);
        }
      });
    });

    // Support deep-linking via URL hash. Stable anchors are the block type
    // (e.g. #faq, #features, #specifications, #custom). Falls back to the
    // lowercased + dash-joined tab label for backwards compatibility.
    function findTabIndexForHash(key) {
      var matchedIndex = -1;
      buttons.forEach(function (btn, i) {
        if (matchedIndex !== -1) return;
        if (btn.dataset.tabKey && btn.dataset.tabKey.toLowerCase() === key) {
          matchedIndex = i;
        }
      });
      if (matchedIndex === -1) {
        buttons.forEach(function (btn, i) {
          if (matchedIndex !== -1) return;
          if (btn.textContent.trim().toLowerCase().replace(/\s+/g, '-') === key) {
            matchedIndex = i;
          }
        });
      }
      return matchedIndex;
    }

    // Tracks the currently highlighted FAQ question (see openFaqDeepLink below)
    // so it can be cleared when the question is closed or a new link is followed.
    var activeFaqHighlight = null;

    function clearFaqHighlight() {
      if (!activeFaqHighlight) return;
      activeFaqHighlight.rowEl.classList.remove('pt-faq-highlight');
      activeFaqHighlight.detailsEl.removeEventListener('toggle', activeFaqHighlight.handler);
      activeFaqHighlight = null;
    }

    // Direct deep link to one FAQ question, e.g. #FAQ-foot-pedal-lock, where
    // the suffix is the FAQ metaobject's handle. Activates the FAQ tab,
    // expands that question's disclosure, and scrolls it into view.
    function openFaqDeepLink(rawKey, skipScroll) {
      if (rawKey.toLowerCase().indexOf('faq-') !== 0) return false;
      var faqEl = document.getElementById(rawKey);
      var faqIndex = findTabIndexForHash('faq');
      if (!faqEl || faqIndex === -1) return false;

      activateTab(faqIndex);
      if (typeof faqEl.open === 'function') faqEl.open();
      if (!skipScroll) {
        faqEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

        var detailsEl = faqEl.querySelector('details');
        var rowEl = faqEl.closest('.collapsible-tabs__tab');
        var alreadyActive = activeFaqHighlight && activeFaqHighlight.detailsEl === detailsEl;

        if (!alreadyActive) {
          clearFaqHighlight();
          if (rowEl && detailsEl) {
            rowEl.classList.add('pt-faq-highlight');
            var handler = function () {
              if (!detailsEl.open) clearFaqHighlight();
            };
            detailsEl.addEventListener('toggle', handler);
            activeFaqHighlight = { rowEl: rowEl, detailsEl: detailsEl, handler: handler };
          }
        }
      }
      return true;
    }

    function checkHash(skipScroll) {
      var hash = window.location.hash;
      if (!hash) return;
      var rawKey = hash.slice(1);

      if (openFaqDeepLink(rawKey, skipScroll)) return;

      clearFaqHighlight();

      var matchedIndex = findTabIndexForHash(rawKey.toLowerCase());
      if (matchedIndex !== -1) {
        activateTab(matchedIndex);
        if (!skipScroll) {
          wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }

    // Skip the initial scroll on back/forward navigation so the browser's
    // restored scroll position isn't overridden.
    var isBackForward = false;
    try {
      var navEntries = performance.getEntriesByType && performance.getEntriesByType('navigation');
      isBackForward = !!(navEntries && navEntries[0] && navEntries[0].type === 'back_forward');
    } catch (e) { /* noop */ }

    checkHash(isBackForward);
    window.addEventListener('hashchange', function () { checkHash(false); });

    // Intercept in-page anchor link clicks that target one of our tab keys.
    // Prevents the browser's native anchor jump (which would otherwise scroll
    // to any element on the page that happens to share the id, e.g. id="faq")
    // before our smooth scroll runs, eliminating the visible scroll fight.
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var link = e.target.closest && e.target.closest('a[href^="#"]');
      if (!link) return;
      var href = link.getAttribute('href');
      if (!href || href === '#') return;
      var rawKey = href.slice(1);
      var key = rawKey.toLowerCase();
      var isFaqLink = key.indexOf('faq-') === 0;
      if (!isFaqLink && findTabIndexForHash(key) === -1) return;
      e.preventDefault();
      if ((window.location.hash || '').slice(1) === rawKey) {
        checkHash(false);
      } else {
        // Preserve the href's exact case: FAQ ids are case-sensitive metaobject handles.
        history.pushState(null, '', '#' + rawKey);
        checkHash(false);
      }
    });
  }

  // Init all tab instances on the page
  document.querySelectorAll('.product-tabs').forEach(function (wrapper) {
    initProductTabs(wrapper);
  });
})();

/* ==========================================================================
   Features Accordion JS
   ========================================================================== */

(function () {
  'use strict';

  function initAccordion(accordion) {
    accordion.querySelectorAll('.pf-accordion__row').forEach(function (row) {
      var trigger = row.querySelector('.pf-accordion__trigger');
      var panel   = row.querySelector('.pf-accordion__panel');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = row.classList.contains('is-open');

        // Close all other rows first
        accordion.querySelectorAll('.pf-accordion__row').forEach(function (otherRow) {
          if (otherRow === row) return;
          var otherTrigger = otherRow.querySelector('.pf-accordion__trigger');
          var otherPanel   = otherRow.querySelector('.pf-accordion__panel');
          var otherVideo   = otherPanel ? otherPanel.querySelector('video') : null;
          otherRow.classList.remove('is-open');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
          if (otherPanel) otherPanel.setAttribute('hidden', '');
          if (otherVideo) otherVideo.pause();
        });

        // Toggle the clicked row
        row.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));

        var video = panel.querySelector('video');

        if (isOpen) {
          panel.setAttribute('hidden', '');
          if (video) { video.pause(); }
        } else {
          panel.removeAttribute('hidden');
          if (video) { video.play(); }
        }
      });

      trigger.addEventListener('keydown', function (e) {
        var triggers = Array.from(accordion.querySelectorAll('.pf-accordion__trigger'));
        var idx = triggers.indexOf(trigger);
        if (e.key === 'ArrowDown') { e.preventDefault(); if (triggers[idx + 1]) triggers[idx + 1].focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); if (triggers[idx - 1]) triggers[idx - 1].focus(); }
        else if (e.key === 'Home') { e.preventDefault(); triggers[0].focus(); }
        else if (e.key === 'End') { e.preventDefault(); triggers[triggers.length - 1].focus(); }
      });
    });
  }

  document.querySelectorAll('[data-pf-accordion]').forEach(function (el) {
    initAccordion(el);
  });
})();


/* ==========================================================================
   Features disclosure videos — play on open, pause on close
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('.product-tabs__features .disclosure').forEach(function (details) {
    var video = details.querySelector('video');
    if (!video) return;

    details.addEventListener('toggle', function () {
      if (details.open) {
        var p = video.play();
        if (p && typeof p.catch === 'function') p.catch(function () {});
      } else {
        video.pause();
      }
    });
  });
})();

/* ==========================================================================
   Mobile Dropdown Nav JS
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('.product-tabs__dropdown').forEach(function (dropdown) {
    var trigger = dropdown.querySelector('.product-tabs__dropdown-trigger');
    var menu    = dropdown.querySelector('.product-tabs__dropdown-menu');
    var items   = dropdown.querySelectorAll('.product-tabs__dropdown-item');
    if (!trigger || !menu) return;

    // Toggle menu
    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', String(!isOpen));
      if (isOpen) {
        menu.setAttribute('hidden', '');
      } else {
        menu.removeAttribute('hidden');
      }
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!dropdown.contains(e.target)) {
        trigger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');
      }
    });

    // Item click — close the menu and activate the matching desktop tab.
    // activateTab() syncs dropdown item state and label, so no duplicate work here.
    items.forEach(function (item) {
      item.addEventListener('click', function () {
        var index = item.dataset.tabIndex;

        trigger.setAttribute('aria-expanded', 'false');
        menu.setAttribute('hidden', '');

        var wrapper = dropdown.closest('.product-tabs');
        if (!wrapper) return;
        var matchingBtn = wrapper.querySelector('.product-tabs__btn[data-tab-index="' + index + '"]');
        if (matchingBtn) matchingBtn.click();
      });
    });
  });
})();

/* ==========================================================================
   Variant Spec Grid JS
   Renders spec cells from window.__productTabsSpecData and updates on
   variant change.
   ========================================================================== */

(function () {
  'use strict';

  var specData = window.__productTabsSpecData || {};
  if (!Object.keys(specData).length) return;

  document.querySelectorAll('[data-spec-grid]').forEach(function (grid) {
    var lastId = window.__productTabsSelectedVariant || null;
    var rendered = false;

    function renderSpecs(variantId) {
      if (!variantId) return;
      var id = String(variantId);
      var specs = (specData[id] || []).filter(Boolean);

      grid.innerHTML = '';
      rendered = true;

      specs.forEach(function (spec) {
        var cell = document.createElement('div');
        cell.className = 'product-tabs__spec-cell';

        if (spec.title) {
          var label = document.createElement('div');
          label.className = 'product-tabs__spec-cell-label';
          label.textContent = spec.title;
          cell.appendChild(label);
        }

        if (spec.description) {
          var value = document.createElement('div');
          value.className = 'product-tabs__spec-cell-value rte';
          value.innerHTML = spec.description;
          cell.appendChild(value);
        }

        grid.appendChild(cell);
      });
    }

    // Render on load if we have a variant
    if (lastId) renderSpecs(lastId);

    // Re-render when specs tab is clicked — covers hidden panel on load
    // AND the no-variant-selected case (uses current form value as fallback)
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-tab-key="specifications"]');
      if (!btn) return;
      var id = lastId || getFormVariantId();
      if (id) renderSpecs(id);
    });

    function handleVariantChange(variantId) {
      if (!variantId) return;
      var id = String(variantId);
      lastId = id;
      renderSpecs(id);
    }

    function getFormVariantId() {
      var form = document.querySelector('form[action*="/cart"]');
      var input = form ? form.querySelector('input[name="id"]') : document.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    // Catch variant:change events fired before our JS was ready
    if (window.__productTabsLastVariantChange) {
      handleVariantChange(window.__productTabsLastVariantChange);
    }

    // Watch for URL gaining ?variant= param (theme updates URL early via replaceState)
    var _replace = history.replaceState;
    history.replaceState = function () {
      _replace.apply(history, arguments);
      var url = arguments[2] ? String(arguments[2]) : '';
      var match = url.match(/[?&]variant=(\d+)/);
      if (match) handleVariantChange(match[1]);
    };

    // Form change events
    document.addEventListener('change', function (e) {
      if (e.target.name === 'id') { handleVariantChange(e.target.value); return; }
      if (e.target.closest('form[action*="/cart/add"]')) {
        setTimeout(function () { var id = getFormVariantId(); if (id) handleVariantChange(id); }, 50);
      }
    });

    // Custom theme events
    ['variant:changed', 'variantChanged', 'product:variant-change', 'theme:variant:changed', 'on:variant:change'].forEach(function (evt) {
      document.addEventListener(evt, function (e) {
        var d = e.detail || {};
        var id = (d.variant && d.variant.id) || d.variantId || d.id;
        if (id) handleVariantChange(String(id));
      });
    });

    // URL changes
    function checkUrl() {
      var id = new URLSearchParams(window.location.search).get('variant');
      if (id) handleVariantChange(id);
    }
    var _push = history.pushState;
    history.pushState = function () { _push.apply(history, arguments); setTimeout(checkUrl, 50); };
    window.addEventListener('popstate', function () { setTimeout(checkUrl, 50); });

    // Polling — runs for first 15 seconds to catch late variant selections
    var pollId = setInterval(function () {
      var id = getFormVariantId();
      if (id && id !== lastId) handleVariantChange(id);
    }, 300);
    setTimeout(function () { clearInterval(pollId); }, 15000);
  });

})();

/* ==========================================================================
   Spec variant selector JS
   ========================================================================== */

(function () {
  'use strict';

  document.querySelectorAll('[data-spec-variant-select]').forEach(function (select) {
    // When spec selector changes, update the PDP variant picker
    select.addEventListener('change', function () {
      var variantId = select.value;
      if (!variantId) return;

      var variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return;

      // Get variant data from the picker's JSON
      var dataEl = variantPicker.querySelector('[type="application/json"]');
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var variant = data.variants.find(function (v) { return String(v.id) === String(variantId); });
      if (!variant) return;

      // For each option, find and trigger the matching input or dropdown option
      variantPicker.querySelectorAll('.option-selector:not(.option-selector--custom)').forEach(function (selector, index) {
        var optionValue = variant.options[index];
        if (!optionValue) return;

        if (selector.dataset.selectorType === 'dropdown') {
          // Custom select dropdown
          var optionEl = selector.querySelector('.custom-select__option[data-value="' + optionValue + '"]');
          if (optionEl) {
            var customSelect = optionEl.closest('custom-select');
            if (customSelect && typeof customSelect.selectOption === 'function') {
              customSelect.selectOption(optionEl);
            }
          }
        } else {
          // Radio input
          var input = selector.querySelector('input[value="' + optionValue + '"]');
          if (input && !input.checked) {
            input.checked = true;
            input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false }));
          }
        }
      });
    });

    // Keep spec selector in sync when variant changes via the PDP picker
    document.addEventListener('on:variant:change', function (e) {
      var variant = e.detail && e.detail.variant;
      if (variant && String(variant.id) !== select.value) {
        select.value = String(variant.id);
      }
    });
  });

})();

/* ==========================================================================
   Reduced motion — pause autoplay videos in accordion panels
   ========================================================================== */

(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('.pf-accordion__panel video[autoplay]').forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
    });
  }
})();

/* ==========================================================================
   FAQ Search JS
   Scopes search to .pt-faq-search-scope, filters .collapsible-tabs__tab
   elements, and hides .collapsible-tabs__heading when all siblings hidden.
   ========================================================================== */

(function () {
  'use strict';

  function initFaqSearch(input) {
    var scope = input.closest('.pt-faq-search-scope');
    if (!scope) return;

    function getTerms(val) {
      var terms = [];
      var parts = val.split(/\s+/);
      for (var i = 0; i < parts.length; i++) {
        var t = parts[i].toLowerCase();
        if (t.length > 0) terms.push(t);
      }
      return terms;
    }

    function allTermsMatch(text, terms) {
      var lower = text.toLowerCase();
      for (var i = 0; i < terms.length; i++) {
        if (lower.indexOf(terms[i]) === -1) return false;
      }
      return true;
    }

    function updateHeadings() {
      var headings = scope.querySelectorAll('.collapsible-tabs__heading');
      for (var h = 0; h < headings.length; h++) {
        var heading = headings[h];
        var sibling = heading.nextElementSibling;
        var allHidden = true;
        while (sibling && !sibling.classList.contains('collapsible-tabs__heading')) {
          if (sibling.classList.contains('collapsible-tabs__tab') && !sibling.classList.contains('pt-faq-hidden')) {
            allHidden = false;
            break;
          }
          sibling = sibling.nextElementSibling;
        }
        if (allHidden) {
          heading.classList.add('pt-faq-hidden');
        } else {
          heading.classList.remove('pt-faq-hidden');
        }
      }
    }

    function performSearch() {
      var terms = getTerms(input.value);
      var tabs = scope.querySelectorAll('.collapsible-tabs__tab');
      for (var i = 0; i < tabs.length; i++) {
        var tab = tabs[i];
        if (!terms.length || allTermsMatch(tab.textContent, terms)) {
          tab.classList.remove('pt-faq-hidden');
        } else {
          tab.classList.add('pt-faq-hidden');
        }
      }
      updateHeadings();
    }

    input.addEventListener('keyup', performSearch);
    input.addEventListener('change', performSearch);
    input.addEventListener('paste', performSearch);
  }

  document.querySelectorAll('.pt-faq-search__input').forEach(function (input) {
    initFaqSearch(input);
  });

})();

